/* eslint-disable react/prop-types */
import React, {useState, useRef, useEffect, useCallback} from 'react';

import {mergeRefs} from './refHelper';
import {toFixedFloor} from './numericHelper';

export default function withScrollInput(WrappedComponent) {
  return React.forwardRef(
    ({min = -9999, max = 9999, value, onChange, increment = 0.1, precision = 1, needFocus, ...props}, ref) => {
      const [focus, setFocus] = useState(false);
      const inputRef = useRef();

      const handleOnWheel = useCallback(
        (e) => {
          e.preventDefault();
          if ((needFocus && focus) || !needFocus) {
            const roundedMax = toFixedFloor(max, precision);

            const delta = e.deltaY > 0 ? -1 * increment : increment;
            const oldValue = parseFloat(value);
            const newValue =
              parseFloat(oldValue + delta).toFixed(precision) > roundedMax ||
              parseFloat(oldValue + delta).toFixed(precision) < min
                ? oldValue
                : oldValue + delta;

            onChange(parseFloat(newValue).toFixed(precision));
          }
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [value, focus, increment, min, max],
      );

      const handleClick = useCallback(() => {
        setFocus(true);
      }, []);

      const handleMouseLeave = useCallback(() => {
        setFocus(false);
      }, []);

      useEffect(() => {
        const input = inputRef.current;
        input.addEventListener('wheel', handleOnWheel);
        input.addEventListener('click', handleClick);
        input.addEventListener('mouseleave', handleMouseLeave);
        return () => {
          input.removeEventListener('wheel', handleOnWheel);
          input.removeEventListener('click', handleClick);
          input.removeEventListener('mouseleave', handleMouseLeave);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
      }, [focus, value, inputRef.current, increment, min, max]);

      return (
        <WrappedComponent
          ref={mergeRefs(ref, inputRef)}
          min={min}
          max={max}
          value={value}
          onChange={onChange}
          increment={increment}
          precision={precision}
          // eslint-disable-next-line react/jsx-props-no-spreading
          {...props}
        />
      );
    },
  );
}
